// extracted by mini-css-extract-plugin
export default {"template":"styles_template__pJk1E","listAccent":"styles_listAccent__-ZVDm"};